module.exports = __webpack_public_path__ + "static/media/fb.837ca175.png";